export default {
  dashboard: [],

  transactionReport: [],
};
